export const recordDialog = {
  "title": "",
  "tab1": "",
  "tab2": "",
  "tableFirstColumn": "",
  "tableSecondColumn": "",
  "tableThirdColumn": "",
  "participateSignature": "",
  "personalSignature": "",
  "initiateSignature": "",
  "docNumber": "",
  "notDocNumber": "",
  "notUsed": "",
  "outTipsOfOrg": "",
  "outTipsOfPerson": "",
  "outTipsOfOrg1": "",
  "outTipsOfPerson1": "",
  "outTips": "",
  "outTips1": "",
  "outTips2": "",
  "outTips3": "",
  "buyNow": "",
  "contactSales": "",
  "inTips": "",
  "inTips1": "",
  "total": "",
  "item": ""
}